body.content-navigation-block-open {
  overflow: hidden;
}
content-navigation-block {
  button {
    appearance: none;
    border: none;
    background: transparent;
    cursor: pointer;
  }
  
  .content-navigation-block__skip-content a, .content-navigation-block__skip-content button, .content-navigation-block__skip-content a:visited, .content-navigation-block__skip-content button:visited{
    border: 2px solid rgba(0,0,0, 1);
    border-radius: 2px;
    color: purple;
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    line-height: 20px;
    margin: 6px 11px;
    min-height: 32px;
    text-decoration: underline;
    text-align: center;
    width: 106px;
    z-index: 1000;
  }
  .content-navigation-block__skip-content:not(:focus-within) {
    position: absolute;
    // z-index: -1;

    clip: rect(1px,1px,1px,1px);
    overflow: hidden;
    padding: 0;
  }

  svg.default-icon {
    display: inline-block;
    width: 32px;
  }
  &[hamburger="fixed"],
  &[hamburger="absolute"],
  &[hamburger="static"] {
    display: inline-block;
    &[aria-expanded="false"] {
      .content-navigation__close {
        display: none;
      }
    }
    .content-navigation__open,
    .content-navigation__close {
      cursor: pointer;
    }
    
    .content-navigation__content-wrapper {
      display: none;
      &[hidden="false"] {
        display: block;
      }
    }
  }

  &[hamburger="fixed"] {
    .content-navigation__content-wrapper {
      position: fixed;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      z-index: 100;
    }
  }
  &[hamburger="sticky"] {
    .content-navigation__content-wrapper {
      position: sticky;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      z-index: 100;
    }
  }
  &[hamburger="absolute"] {
    .content-navigation__content-wrapper {
      position: absolute;
      z-index: 100;
    }
  }
  &[hamburger="static"] {
    .content-navigation__content-wrapper {
      position: static;
    }
  }
  
  &[hamburger="none"] {
    display: block;
    .content-navigation__open,
    .content-navigation__close {
      display: none;
    }
  }

  &[aria-expanded="true"] {
    .content-navigation__content-wrapper {
      display: block;
    }
  }
}